import {
  Input,
  Component,
  EventEmitter,
  Output,
  AfterContentInit,
  ChangeDetectorRef
} from "@angular/core";
import { CRUDColumn } from "./crud-column";
import * as _ from "lodash";
@Component({
  selector: ".crud-dom",
  templateUrl: "./crud-dom.html"
})
export class CrudDomComponent implements AfterContentInit {
  @Input() showCheckbox: boolean = true;
  private _rows: any[] = [];
  @Input() set rows(rows: any[]) {
    this._rows = _.clone(rows).map((el, index) => {
      if (!el.id) {
        el.tableId = el._id ? el._id : index;
      } else {
        el.tableId = el.id;
      }
      return el;
    });
    if (this.expandableRow) {
      this.checkRoxExpanded();
    }
  }
  get rows() {
    return this._rows;
  }
  //@Input() class = 'ngx-datatable table-stripped table-hover table-condensed table-bordered';
  @Input() headerHeight: number = 50;
  @Input() footerHeight: number = 50;
  @Input() rowHeight: number = 40;
  @Input() limit: number = 20;
  @Input() offset: number = 0;
  @Input() selected: any[] = [];
  @Input() selectionType: "multiple" | "single" = "single";
  @Input() selectCheck = undefined;
  @Input() loadingIndicator = false;
  @Input() sorts = undefined;
  @Input() externalPaging = false;
  @Input() externalSorting = "isServerSide";
  @Input() columns: CRUDColumn[];
  @Input() count: number = 0;
  @Input() isLoading: boolean = false;
  @Input() showPagination: boolean = true;
  @Input() isServerSide: boolean = false;
  @Input() paginationPosition: "top" | "bottom" | "both" = "bottom";
  @Input() bordered: boolean = true;
  @Input() size: string = "small";
  @Input() total: number;
  @Input() expandableRow: boolean = false;
  @Input() expandableRowPropBL: string[] = [];
  @Input() showActionColumn: boolean = false;

  isAllDisplayDataChecked = false;
  mapOfCheckedId: { [key: string]: boolean } = {};
  mapOfExpandData: { [key: string]: boolean } = {};
  numberOfChecked = 0;
  isIndeterminate = false;
  expandableRowAll: boolean = false;
  @Output("changePage") changePageEvent: EventEmitter<
    number
  > = new EventEmitter();
  @Output("checkedAll") checkedAllEvent: EventEmitter<
    void
  > = new EventEmitter();
  @Output("onSort") onSortEvent: EventEmitter<{
    prop: string;
    type: "asc" | "desc";
  }> = new EventEmitter();
  @Output("onSelect") onSelectEvent: EventEmitter<{
    selected: any[];
  }> = new EventEmitter();
  @Output("refreshCrud") refreshCrudEvent: EventEmitter<
    boolean
  > = new EventEmitter();
  @Output("rowButtonClick") rowButtonClickEvent: EventEmitter<
    boolean
  > = new EventEmitter();
  constructor(private cd: ChangeDetectorRef) { }
  refreshStatus(): void {
    this.isAllDisplayDataChecked = this.rows
      .filter(item => !item.disabled)
      .every(item => this.mapOfCheckedId[item.tableId]);
    this.isIndeterminate =
      this.rows
        .filter(item => !item.disabled)
        .some(item => this.mapOfCheckedId[item.tableId]) &&
      !this.isAllDisplayDataChecked;
    this.numberOfChecked = this.rows.filter(
      item => this.mapOfCheckedId[item.tableId]
    ).length;
    this.selected = this.rows.filter(item => this.mapOfCheckedId[item.tableId]);
    this.onSelectEvent.emit({ selected: this.selected });
  }
  checkAll(value: boolean): void {
    this.rows
      .filter(item => !item.disabled)
      .forEach(item => (this.mapOfCheckedId[item.tableId] = value));
    this.refreshStatus();
    this.checkedAllEvent.emit();
  }
  setSelect(tableId) {
    if (this.selectionType == "single") {
      this.mapOfCheckedId = {};
    }
    this.mapOfCheckedId[tableId] = true;
  }
  throwOnSortEvent(event) {
    this.changePageEvent.emit(event);
  }
  throwChangePageEvent($offset) {
    this.changePageEvent.emit($offset);
  }
  extractValueFromQueryParams(colQueryParams, row) {
    const obj = {};
    for (let qpi in colQueryParams) {
      const qp = colQueryParams[qpi];
      if (qp.indexOf(":") == -1) {
        obj[qpi] = qp; //casistica di un parametro passato direttamente /mezzi/
      } else {
        const propName = qp.substring(1); //rimuovo il ':' iniziale
        obj[qpi] = "" + row[propName];
      }
    }
    return obj;
  }
  //sfdas/:id
  extractValueFromParams(colParams: string[], row) {
    const finalArrayMapped = [];
    for (let param of colParams) {
      if (param.indexOf(":") == -1) {
        finalArrayMapped.push(param); //casistica di un parametro passato direttamente /mezzi/
      } else {
        const propName = param.substring(1); //rimuovo il ':' iniziale
        finalArrayMapped.push("" + row[propName]);
      }
    }
    return finalArrayMapped;
  }
  ngAfterContentInit(): void {
    this.cd.detectChanges();
  }
  mergeArray(...arrays) {
    const finalArray = _.flatten(arrays);
    return finalArray;
  }
  isPropColumn(prop: string) {
    return this.columns.find(el => el.prop == prop) !== undefined || this.expandableRowPropBL.find(el => el == prop) !== undefined;
  }
  changeExpandableRowAll() {
    this.expandableRowAll = !this.expandableRowAll;
    this.checkRoxExpanded();
  }
  checkRoxExpanded() {
    if (this.expandableRowAll) {
      for (let row of this.rows) {
        this.mapOfExpandData[row.id] = true;
      }
    } else {
      this.mapOfExpandData = {};
    }
  }
  handlerABUpdate(onUpdate: boolean) {
    this.refreshCrudEvent.emit(onUpdate);
  }
  getTitleParsed(col: CRUDColumn, row: any) {
    let value = row[col.prop ? col.prop : col.name];
    if (col.titleProp) {
      value = row[col.titleProp]
    } else if (col.isCustomHtml) {
      value = null;
    }
    return typeof value == "object" ? null : value
  }
  btnHandler(event){
    //rimando su l'evento dei row buttons della crud
    this.rowButtonClickEvent.emit(event);
  }
}
